export const STREAMS = {
    'français': [
        {
            name: 'movix',
            url: 'https://movix.rodeo/search?q=',
            color: '#f73333'
        },
        {
            name: 'flixer',
            url: 'https://flixer.sh/search?q=',
            color: '#f00'
        },
        {
            name: 'afterdark',
            url: 'https://afterdark.mom/search?q=',
            color: '#fff'
        },
    ],
    'anglais': [
        {
            name: 'aether',
            url: 'https://aether.mom/browse/',
            color: '#7abfff'
        },
    ],
}